import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";

interface AutocompleteInputProps {
  options: string[];
  onSelect: (value: string) => void;
  defaultValue: string;
  error: string;
}

const AutocompleteInput: React.FC<AutocompleteInputProps> = ({ options, onSelect, defaultValue = "", error = "" }) => {
  const [inputValue, setInputValue] = useState<string>("");
  const [showDropdown, setShowDropdown] = useState<boolean>(false);

  const filteredOptions = options.filter((opt) => opt.toLowerCase().includes(inputValue.toLowerCase()));

  useEffect(() => {
    setInputValue(defaultValue);
  }, [defaultValue]);

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    setShowDropdown(true);
    onSelect(e.target.value);
  };

  const handleSelect = (value: string) => {
    setInputValue(value);
    setShowDropdown(false);
    onSelect(value);
  };

  const handleBlur = () => {
    // Delay hiding to allow item click
    setTimeout(() => setShowDropdown(false), 200);
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
      onSelect(inputValue); // Accept even if it's a new value
      setShowDropdown(false);
    }
  };

  return (
    <div style={{ position: "relative" }}>
      <Form.Control
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlur}
        onFocus={() => setShowDropdown(true)}
        placeholder="Type or select a value"
        isInvalid={error ? true : false}
      />
      {showDropdown && (filteredOptions.length > 0 || inputValue) && (
        <Dropdown.Menu show style={{ width: "100%" }}>
          {filteredOptions.map((option, idx) => (
            <Dropdown.Item key={idx} onClick={() => handleSelect(option)}>
              {option}
            </Dropdown.Item>
          ))}
          {inputValue && !filteredOptions.includes(inputValue) && (
            <Dropdown.Item onClick={() => handleSelect(inputValue)}>Add "{inputValue}"</Dropdown.Item>
          )}
        </Dropdown.Menu>
      )}
      {error && (
        <Form.Control.Feedback style={{ textAlign: "right" }} type="invalid">
          {error}
        </Form.Control.Feedback>
      )}
    </div>
  );
};

export default AutocompleteInput;
